import AbstractModal from 'static/script/utils/abstract-modal';
import WithAjax from 'static/script/app/data/with-ajax';
import 'flight';

function NativeAppBetaSignupModalUI() {

    this.defaultAttrs({
        noButton: '[data-native-beta-no]',
        yesButton: '[data-native-beta-yes]',
        signUpLink: null,
        betaOptOutGroup: null
    });


    this._readMore = function () {
        this.trigger(document,
            'data:native-app-beta-signup:submit', {
                groupName: this.attr.betaOptOutGroup
            });
        this.trigger('ui:modal:close');
        window.location.href = this.attr.signUpLink;
    };
    this._reject = function () {
        this.trigger(document,
            'data:native-app-beta-optout:submit', {
                groupName: this.attr.betaOptOutGroup
            });
        this.trigger('ui:modal:close');
    };
    this._afterOptout = function () {
    };
    this.after('initialize',
        function () {
            this.on('click', {
                yesButton: this._readMore,
                noButton: this._reject
            });
        });

}

module.exports = AbstractModal.mixin(NativeAppBetaSignupModalUI, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/beta-signup/native-app-beta-signup-modal-ui.js